<template>
  <div class="pair">
  <form v-on:submit="onSubmit">
  <div class="row justify-content-center">
    <div class="col-10">
        <b-progress :value="attempted" :max="total" class="mb-3" variant="success"></b-progress>
        <div id="inst">
        <p>Instructions</p>
        <ol class="text-left">
          <li>First choose the item in the column that is more like you.</li>
          <li>Then rate how much it is like you from 1 - 7 with 7 the highest rating you can give.</li>
          <li>Both choices may feel like you; choose and rate the strongest choice. You will choose the column and rate your choice on every page of the survey to follow.</li>
        </ol>
        </div>
        
    </div>
  </div>
  <br>
  <div class="row justify-content-center">
    <div class="col-md-5">
        <h4>COLUMN A</h4>
        <hr>
        <p>{{questionData.q1}}</p>
        
            <div class="score-box">
                <p><b>Rating</b></p>
                <!-- radio Section -->
                <div class="form-check form-check-inline">
                    <label class="form-check-label">
                        <input class="form-check-input" type="radio" name="score" value="1" v-model="form.score"> 1
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="form-check-label">
                        <input class="form-check-input" type="radio" name="score"  value="2" v-model="form.score"> 2
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="form-check-label">
                        <input class="form-check-input" type="radio" name="score" value="3" v-model="form.score"> 3
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="form-check-label">
                        <input class="form-check-input" type="radio" name="score" value="4" v-model="form.score"> 4
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="form-check-label">
                        <input class="form-check-input" type="radio" name="score" value="5" v-model="form.score"> 5
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="form-check-label">
                        <input class="form-check-input" type="radio" name="score" value="6" v-model="form.score"> 6
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="form-check-label">
                        <input class="form-check-input" type="radio" name="score" value="7" v-model="form.score"> 7
                    </label>
                </div>
                <div class="width-100"></div>
                <div class="row">
                <div class="col"><p style="margin-left:10%;margin-bottom:0; font-size:14px;" class="float-left">Lowest</p></div>
                <div class="col"><p style="margin-right:10%;margin-bottom:0; font-size:14px;" class="float-right" >Highest</p></div>
                </div>
            </div>
       
    </div>
    <div class="col-md-2">
        <h3>OR</h3>
    </div>
    <div class="col-md-5">
        <h4>COLUMN B</h4>
        <hr>
        <p>{{questionData.q2}}</p>
        <div class="score-box">
                <p><b>Rating</b></p>
                <!-- radio Section -->
                <div class="form-check form-check-inline">
                    <label class="form-check-label">
                        <input class="form-check-input" type="radio" name="score" value="8" v-model="form.score"> 1
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="form-check-label">
                        <input class="form-check-input" type="radio" name="score" value="9" v-model="form.score"> 2
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="form-check-label">
                        <input class="form-check-input" type="radio" name="score" value="10" v-model="form.score"> 3
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="form-check-label">
                        <input class="form-check-input" type="radio" name="score" value="11" v-model="form.score"> 4
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="form-check-label">
                        <input class="form-check-input" type="radio" name="score" value="12" v-model="form.score"> 5
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="form-check-label">
                        <input class="form-check-input" type="radio" name="score" value="13" v-model="form.score"> 6
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="form-check-label">
                        <input class="form-check-input" type="radio" name="score" value="14" v-model="form.score"> 7
                    </label>
                </div>
                <div class="width-100"></div>
                <div class="row">
                <div class="col"><p style="margin-left:10%;margin-bottom:0; font-size:14px;" class="float-left">Lowest</p></div>
                <div class="col"><p style="margin-right:10%;margin-bottom:0; font-size:14px;" class="float-right" >Highest</p></div>
                </div>
            </div>
    </div>
  </div>
  <br><br>
  <div class="row justify-content-center">
        <div class="col-md-3">
            <button type="submit" :disabled="form.score == null" class="btn btn-primary btn-block">Continue</button>
        </div>
  </div>
   </form>
  </div>
</template>

<script>

const apiUrl = 'https://t3.talkingtowardtruth.org/api/';
var used_id = 0;
var scoreData = {};
export default {
  name: 'Pair',
  
  
  data () {
    return {
      form : {
          score : null
      },
      attempted : 0,
      total : 0,
      questionData : {
      q1 : '',
      q2 : ''
  }
    }
  },
  methods :{
      onSubmit : function(e){
          e.preventDefault();
          var user_id = this.$cookie.get('user_id');
          if(this.form.score > 7){
              scoreData= {
                  question_id : this.questionData.q2_id,
                  user_id : user_id,
                  pair_id : this.questionData.pair_id,
                  score : this.form.score - 7
              }
          }else{
             scoreData= {
                  question_id : this.questionData.q1_id,
                  user_id : user_id,
                  pair_id : this.questionData.pair_id,
                  score : this.form.score
              }
          }
          console.log(scoreData);
          this.postScore(scoreData);
          
      },
      getPair : function() {
            console.log('Getting Pair')
            this.getAttempted();
          var user_id = this.$cookie.get('user_id');
            
           this.$http.get(apiUrl+'pair/random/'+user_id).then(response=>{
                
                this.questionData = response.body;
                if(response.body){
                        this.postAttempt({
                    user_id : this.$cookie.get('user_id'),
                    pair_id : response.body.pair_id
                });
                }
                
                if(!response.body){
                    this.$router.push('results');
                    if(!this.$cookie.get('sent')){
                    this.emailReport();
                    this.$cookie.set('sent','true')                        
                    }
                }
            },error=>{
                console.log(error);
            })

        },
        getTotal : function(){
             this.$http.get(apiUrl+'pair_count').then(response => {
                this.total = response.body.count;
             },error=>{})
        },
        getAttempted : function(){
            var user_id = this.$cookie.get('user_id');
            this.$http.get(apiUrl+'attempted_count/'+user_id).then(response => {
                this.attempted = response.body.count;
             },error=>{})
        },
      checkFailedAttempt : function(){
            var user_id = this.$cookie.get('user_id');
            
            this.$http.get(apiUrl+'attempt/failed/'+user_id+'/all').then(response => {
                if(response.body){
                    var pair_id= response.body.pair_id
                    this.$http.get(apiUrl+'pair/'+pair_id).then(response=>{
                
                        this.questionData = response.body;
                if(!response.body){
                    this.getPair();
                }
            },error=>{
                console.log(error);
            })

                }else{
                    this.getPair();
                }
            })   
            this.getAttempted();         
      },
      postAttempt : function(data){

        this.$http.post(apiUrl+'attempt',data).then(response => {
            console.log('Un answered attempt posted');
        },error=>{})
      },
      updateAttemptStatus : function(){
            var pair_id= this.questionData.pair_id;
            var user_id = this.$cookie.get('user_id');

            this.$http.put(apiUrl+'attempt/'+user_id+'/'+pair_id,{
                status : 'Y'
            }).then(response => {
                    console.log('attempt updated');
            },error => {

            })
      },
      postScore : function(score){
            this.$http.post(apiUrl+'score',score).then(response => {
                this.form = {
                    score : null
                };
                this.getPair();
                this.updateAttemptStatus();
            }, 
            error =>{
                    location.reload(true);
            })
      }   
      ,
      emailReport : function(){
         var user_id = this.$cookie.get('user_id');
 this.$http.get(apiUrl+'email/'+user_id).then(response => {
                var filename = response.body.filename;
                // alert('Email is sent!');
             },error=>{})
      }  
  },
  created : function(){
      this.getTotal();
      this.checkFailedAttempt();
      
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .score-box{
        padding : 14px;
        display : block;
        background-color : rgba(133, 100, 4, 0.35);
    }
    #inst{
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Pair.vue